import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

//TYPES
import {
  CreateApplicantNotes,
} from "../Types/Applicants/ApplicantsNotes";

export const APPLICANT_NOTES_QUERY_KEY = ["applicant-notes"];
export const VIEW_APPLNOTES_QUERY_KEY = ["view-applicant-notes"];

export const applicantNotesService = {
  createNotes: async (payload: CreateApplicantNotes) => {
    const response = await api.post(`api/applicant-notes`, payload);
    return response.data;
  },
  getByApplication: async (application_no: string) => {
    const response = await api.get(
      `api/applicant-notes/${application_no}/appl-no`,
    );
    return response.data;
  },
  viewByApplication: async (application_no: string) => {
    const response = await api.get(
      `api/view-applicant-notes/${application_no}/appl-no`,
    );
    return response.data.data;
  },
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(`api/applicant-notes/${id}/toggle-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
